import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

export default function Develeoper() {
  useEffect(() => {
    document.title = 'Desire Store - Developer Page';
  }, []);
  const CurrentV = "3.1.1";

  return (
    
    <div>
 <Helmet>
        <title>Discover the Developer Behind DesireStore.Online</title>
        <meta property="og:title" content="Discover the Developer Behind DesireStore.Online"/>
        <meta property="og:site_name" content="Desire Store"/>
        <meta property="og:url" content="https://desirestore.online/developer"/>
        <meta property="og:description" content="Get to know the talented developer behind DesireStore.Online and learn more about the projects they've worked on. With years of experience in web development and a passion for creating high-quality, user-friendly websites, our developer is dedicated to delivering exceptional results for clients. From e-commerce platforms to informational websites, our portfolio showcases a diverse range of projects that demonstrate our expertise and attention to detail. Plus, with a commitment to staying up-to-date with the latest web development trends and technologies, our developer is always pushing the boundaries of what's possible."/>
        <meta property="og:type" content="website"/>
        <meta property="og:image" content="og-images/og-home.png"/>
        <link rel="canonical" href="https://desireStore.online/developer" />

        <meta name="title" content="Discover the Developer Behind DesireStore.Online"/>
        <meta name="description" data-rh="true" content="Get to know the talented developer behind DesireStore.Online and learn more about the projects they've worked on. With years of experience in web development and a passion for creating high-quality, user-friendly websites, our developer is dedicated to delivering exceptional results for clients. From e-commerce platforms to informational websites, our portfolio showcases a diverse range of projects that demonstrate our expertise and attention to detail. Plus, with a commitment to staying up-to-date with the latest web development trends and technologies, our developer is always pushing the boundaries of what's possible."/>
        <meta name="keywords" content="Developer, DesireStore.Online, web development, projects, experience, e-commerce, user-friendly, portfolio, expertise, attention to detail, web development trends, technologies."/>
      </Helmet>
      <div className="container">
       <main>
    
       <p>Current version of Desire Store: <span className="version">OPEN BETA {CurrentV}</span></p>  

       <h2>Developer Introductions</h2>
        <p>Hello and welcome to the developer page for Desire Store! We are a team of developers dedicated to providing a simple and straightforward software downloading experience for our users. Our team consists of:</p>
      <ul>
   <li> Ayush Solanki - Full Stack Developer</li>
   <li>Contact : </li>
   <div className="social">
                    <Link to="https://instagram.com/ayushsolanki.exe?igshid=NzMyMjgxZWIzNw=="> <i className="fab fa-instagram"></i></Link>
                    <Link to="https://github.com/ayushsolanki29"> <i className="fab fa-github"></i></Link>
                    <Link to="mailto:ayushsolanki@gmail.com"> <i className="fa-solid fa-envelope"></i></Link>
                    <Link to="https://twitter.com/ayushSolanki29"><i className="fa-brands fa-twitter"></i></Link>
                </div>
      </ul>
  <h2>Project Details</h2>
  <p>The First version of our project's <span className="version">0.1.0</span>, released on April 14th, 2023. Our project is a software downloading website that offers a wide range of programs for Windows, Mac, and Linux operating systems.</p>
      <h2>Update Logs <span className="version">{CurrentV}</span> (April 27th, 2023)</h2>
      
				<li>Bug Fixes & Performance Improvements.</li>
			
         <p>Our project uses the following dependencies and their respective versions:</p>
        <ul>
        <li>
            React - <span className="version"> 18.2.0</span>
        </li>
           <li>React DOM - <span className="version"> 18.2.0</span> </li>  
           <li>React Router DOM - <span className="version">6.10.0 </span>  </li>  
            <li>Auth0 React - <span className="version">  2.0.1 </span></li> 
           <li>Web Vitals -<span className="version">  2.1.4 </span> </li>
           <li>React Loader Spinner - <span className="version">5.3.4 </span></li>  
        </ul>

      <h2>Mission</h2>
      <p>Our mission is to provide a website that makes software downloading easy and enjoyable for our users. We are committed to offering high-quality software programs with the best possible user experience, and to creating a website that is free from ads, pop-ups, and other distractions. Our goal is to become a trusted source for software downloading and to continue to improve our website and services to meet the evolving needs of our users.</p>
    </main>
    <p>Thank you for using our application. We appreciate your feedback and will continue to make improvements to enhance your experience.</p>
    </div></div>
  )
}

